<template>
    <fieldset :disabled="formDisabled">
        <form class="form form-horizontal" v-on:submit.prevent data-vv-scope="linearResourceForm">
            <div class="form-group" v-bind:class="{ 'has-error': errors.has('linearResourceForm.contributionId') }">
                <label class="col-sm-2 control-label text-label">Resource Segment</label>
                <div class="col-sm-2">
                    <select class="form-control" v-model="linearDto.contributionId" name="contributionId" v-validate="'required'">
                        <option disabled value="">Select a value</option>
                        <option v-for="contribution in contributionList" :value="contribution.contributionId">
                            {{contribution.description}}
                        </option>
                    </select>
                    <span v-show="errors.has('linearResourceForm.contributionId')" class="has-error">{{ errors.first('linearResourceForm.contributionId') }}</span>
                </div>
                <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'contributionId'" :hasAppend="false"></qaqcFormFieldSelect>
            </div>
            <div class="form-group" v-bind:class="{ 'has-error': errors.has('linearResourceForm.portionId') }">
                <label class="col-sm-2 control-label  text-label">Extent Recorded</label>
                <div class="col-sm-2">
                    <select class="form-control" v-model="linearDto.portionId" name="portionId" v-validate="'required'">
                        <option disabled value="">Select a value</option>
                        <option v-for="portion in portionList" :value="portion.portionId">
                            {{portion.description}}
                        </option>
                    </select>
                    <span v-show="errors.has('linearResourceForm.portionId')" class="has-error">{{ errors.first('linearResourceForm.portionId') }}</span>
                </div>
                <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'portionId'" :hasAppend="false"></qaqcFormFieldSelect>
            </div>
            <div class="form-group">
                <label class="col-sm-2 control-label">Dimensions of Linear Feature</label>
                <div class="col-sm-10">
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'topWidth'" :hasAppend="false"></qaqcFormFieldSelect>
                    <div class="form-group">
                        <div v-bind:class="{ 'has-error': errors.has('linearResourceForm.topWidth') }">
                            <label class="col-md-3 control-label">Average top width</label>
                            <div class="col-md-3 form-inline">
                                <input class="form-control" type="number" v-model="linearDto.topWidth" name="topWidth" v-validate="'required'"/>
                                <span v-show="errors.has('linearResourceForm.topWidth')" class="has-error">{{ errors.first('linearResourceForm.topWidth') }}</span>
                            </div>
                        </div>
                        <div v-bind:class="{ 'has-error': errors.has('linearResourceForm.bottomWidth') }">
                            <label class="col-md-3 control-label">Average bottom width</label>
                            <div class="col-md-3 form-inline">
                                <input class="form-control" type="number" v-model="linearDto.bottomWidth" name="bottomWidth" v-validate="'required'"/>
                                <span v-show="errors.has('linearResourceForm.bottomWidth')" class="has-error">{{ errors.first('linearResourceForm.bottomWidth') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div v-bind:class="{ 'has-error': errors.has('linearResourceForm.height') }">
                            <label class="col-md-3 control-label" >Height or depth</label>
                            <div class="col-md-3 form-inline">
                                <input class="form-control" type="number" v-model="linearDto.height" name="height" v-validate="'required'"/>
                                <span v-show="errors.has('linearResourceForm.height')" class="has-error">{{ errors.first('linearResourceForm.height') }}</span>
                            </div>
                        </div>
                        <div v-bind:class="{ 'has-error': errors.has('linearResourceForm.length') }">
                            <label class="col-md-3 control-label">Length of Segment</label>
                            <div class="col-md-3 form-inline">
                                <input class="form-control" type="number" v-model="linearDto.length" name="length" v-validate="'required'"/>
                                <span v-show="errors.has('linearResourceForm.length')" class="has-error">{{ errors.first('linearResourceForm.length') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group" v-bind:class="{ 'has-error': errors.has('linearResourceForm.description') }">
                <label class="col-sm-2 control-label">Narrative Description</label>
                <div class="col-sm-10">
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'description'" :hasAppend="true"></qaqcFormFieldSelect>
                    <textarea class="form-control" rows="6" v-model="linearDto.description" name="description" v-validate="'required'"/>
                    <span v-show="errors.has('linearResourceForm.description')" class="has-error">{{ errors.first('linearResourceForm.description') }}</span>
                </div>
            </div>
            <div class="form-group" v-bind:class="{ 'has-error': errors.has('linearResourceForm.associatedStructures') }">
                <label class="col-sm-2 control-label">Describe associated structures/features</label>
                <div class="col-sm-10">
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'associatedStructures'" :hasAppend="true"></qaqcFormFieldSelect>
                    <textarea class="form-control" rows="6" v-model="linearDto.associatedStructures" name="associatedStructures" v-validate="'required'"/>
                    <span v-show="errors.has('linearResourceForm.associatedStructures')" class="has-error">{{ errors.first('linearResourceForm.associatedStructures') }}</span>
                </div>
            </div>
            <div v-if="!(formDisabled || qaqcEnabled)" class="form-group">
                <div class="col-sm-2">
                    <button class="btn btn-primary" v-on:click="saveLinearResource">Save</button>
                </div>
            </div>
            <qaqcFormFieldFooter v-if="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto" :qaqcSelection="qaqcSelection" :sectionName="'linearResource'" :completeSection="completeSection"></qaqcFormFieldFooter>
        </form>
    </fieldset>
</template>

<script>
import loggingService from '../../services/util/loggingService'
import linearResourceService from '../../services/siteForm/LinearResourceService'
//import qaqcService from '@/services/qaqcService'
import qaqcFormFieldSelect from '@/components/SiteForm/QaqcFormFieldSelect.vue'
import qaqcFormFieldFooter from '@/components/SiteForm/QaqcFormFieldFooter.vue'

export default {
    name: 'linearResourceForm',
    components: {
        qaqcFormFieldSelect,
        qaqcFormFieldFooter
    },
    data: function () {
        return {
            isDebug: false,
            isLoading: false,
            portionList: [],
            contributionList: [],
            linearDto: {
                contributionId: '',
                portionTypeId: ''
            }
        }
    },
    props: {
        attachmentCount: {},
        formDisabled: { default: false },
        qaqcEnabled: { default: false },
        qaqcProgressDto: { default: () => {} },
        saveQaqcProgress: { default: null },
        crrId: { default: null }
    },
    computed: {
        qaqcSelection: function () {
            if (this.qaqcProgressDto && this.qaqcProgressDto.qaqcSelections) {
                // // if there's no linearResource, create new instance
                // if (!this.qaqcProgressDto.qaqcSelections.linearResource) {
                //     this.qaqcProgressDto.qaqcSelections.linearResource = qaqcService.qaqcSelections().linearResource
                // }
                return this.qaqcProgressDto.qaqcSelections.linearResource
            } else {
                return {}
            }
        }
    },
    watch: {
        crrId: function (val) {
            this.log('crrId is changed: ' + val)
            this.loadData().then(result => {
                this.loadLookups()
                this.isLoading = false
            })
        }
    },
    mounted () {
        this.isLoading = true
        if (this.crrId) {
            this.loadData().then(result => {
                this.loadLookups()
                this.isLoading = false
            })
        }
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Linear Resource Form', message)
        },
        loadData () {
            var crr = this.crrId
            return linearResourceService.search(this.$http, {culturalResourceRecordingId: crr}).then(response => {
                if (response.data.length === 0) {
                    this.createLinearDto()
                } else {
                    this.linearDto = response.data[0]
                }
            })
        },
        loadLookups () {
            this.contributionList = [
                {contributionId: 1, description: 'Contributes'},
                {contributionId: 2, description: 'Does not contribute'},
                {contributionId: 3, description: 'Unevaluated'}
            ]
            this.portionList = [
                {portionId: 1, description: 'Segment'},
                {portionId: 2, description: 'Entire Resource'},
                {portionId: 3, description: 'Portion of Segment'}
            ]
        },
        saveLinearResource () {
            this.$validator.validateAll('linearResourceForm').then(result => {
                if (result) {
                    linearResourceService.put(this.$http, this.linearDto).then(response => {
                        this.loadData()
                    })
                } else {
                    this.log('invalid form')
                }
            })
        },
        createLinearDto () {
            this.linearDto = {
                contributionId: '',
                portionTypeId: '',
                culturalResourceRecordingId: this.crrId
            }
        },
        completeSection (sectionName) {
            // set consolidated select fields
            this.qaqcSelection.bottomWidth = this.qaqcSelection.topWidth
            this.qaqcSelection.height = this.qaqcSelection.topWidth
            this.qaqcSelection.length = this.qaqcSelection.topWidth

            // check if all selections have been made
            if (Object.values(this.qaqcSelection).includes(0)) {
                alert('Please complete all QA/QC selections in this section.')
                return
            }
            this.saveLinearResource()
            this.saveQaqcProgress(sectionName, true)
        }
    }
}
</script>



// WEBPACK FOOTER //
// LinearResourceForm.vue?303b9dc6